/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contour-image-container[_ngcontent-%COMP%]{text-align:center;padding:44px 0}.contour-image-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-height:270px}.dialog-row[_ngcontent-%COMP%]{margin-bottom:10px}.dialog-row[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:700;width:181px;display:inline-block}.dialog-row[_ngcontent-%COMP%]:last-child{margin-bottom:0}"];
export { styles as styles };
